import React, { useState, useEffect } from "react";
import Footer from "../components/common/Footer";
import { useParams } from "react-router-dom";
import { apiConnector } from "../services/apiConnector.service";
import { categories } from "../services/apis.service";
import { getCatalogPageData } from "../services/operations/pageAndComponentData.service";
import Course_Card from "../components/core/Catalog/Course_Card";
import Course_Slider from "../components/core/Catalog/Course_Slider";
import { useSelector } from "react-redux";
import Error from "./Error.page";

const Catalog = () => {
  const { loading } = useSelector((state) => state.profile);
  const { catalogName } = useParams();
  const [active, setActive] = useState(1);
  const [catalogPageData, setCatalogPageData] = useState(null);
  const [categoryId, setCategoryId] = useState("");

  //Fetch all categories
  const getCategories = async () => {
    const res = await apiConnector("GET", categories.CATEGORIES_API);
    const category_id = res?.data?.allCategories?.filter(
      (ct) => ct.name.split(" ").join("-").toLowerCase() === catalogName
    )[0]._id;
    setCategoryId(category_id);
  };

  useEffect(() => {
    getCategories();
  }, [catalogName]);

  const getCategoryDetails = async () => {
    try {
      const res = await getCatalogPageData(categoryId);
      setCatalogPageData(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (categoryId) {
      setCatalogPageData(null);
      getCategoryDetails();
    }
  }, [categoryId]);

  const differentCategoriesCourses =
    catalogPageData?.data?.differentCategories?.flatMap(
      (category) => category?.courses || []
    ) || [];

  if (loading) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    );
  }
  if (!catalogPageData) {
    return <Error />;
  }

  return (
    <>
      {/* Hero Section */}
      <div className="box-content bg-richblue-900 border-b border-richblue-300 px-4">
        <div className="mx-auto flex min-h-[260px] max-w-maxContentTab flex-col justify-center gap-4 lg:max-w-maxContent">
          <p className="text-sm text-richblack-300">
            {`Home / Catalog / `}
            <span className="text-yellow-25">
              {catalogPageData?.data?.selectedCategory?.name}
            </span>
          </p>
          <p className="text-3xl text-richblack-5">
            {catalogPageData?.data?.selectedCategory?.name}
          </p>
          <p className="max-w-[870px] text-richblack-200">
            {catalogPageData?.data?.selectedCategory?.description}
          </p>
        </div>
      </div>

      {/* Section-1 */}
      <div className="mx-auto box-content w-11/12 max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">Courses To Get You Started</div>
        <div className="my-4 flex border-b border-b-richblack-600 text-sm">
          <p
            className={`px-4 py-2 ${
              active === 1
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            } cursor-pointer`}
            onClick={() => setActive(1)}
          >
            Most Popular
          </p>
          <p
            className={`px-4 py-2 ${
              active === 2
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            } cursor-pointer`}
            onClick={() => setActive(2)}
          >
            New
          </p>
        </div>
        <div className="w-11/12 mx-auto">
          <Course_Slider
            Courses={catalogPageData?.data?.selectedCategory?.courses}
          />
        </div>
      </div>

      {/* Section-2 */}
      <div className="mx-auto box-content w-11/12 max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">
          Top Courses In{" "}
          {catalogPageData?.data?.differentCategories?.map(
            (category) => category?.name + ", "
          )}
          etc..
        </div>
        <div className="w-11/12 mx-auto py-8">
          <Course_Slider Courses={differentCategoriesCourses} />
        </div>
      </div>

      {/* Section-3 */}
      <div className="mx-auto box-content w-11/12 max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">Frequently Bought</div>
        <div className="py-8">
          <div className="w-11/12 mx-auto py-8">
            <Course_Slider
              Courses={catalogPageData?.data?.topSellingCourses?.slice(0, 4)}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Catalog;
